<template>
  
  <!-- app-layer {admin} -->
  <div class="app-layer admin">

    <transition name="center-modal" v-show="show">

      <div class="modal center" name="" v-if="show" :class="{loading: loading}">

        <!-- ...content here -->

      </div>

    </transition>

  </div>

</template>

<script>
export default{

  props: {
    multiple: {
      type: 'boolean',
      default: false,
      required: false,
    },
    type: 'string',
    default: 'images',
    required: false
  },

  data: function(){

    return {

      loading: false,
      show: false,

      // ... modal data
      media_loading: false,
      media: [],
      selected: []

    }

  },

  methods: {

    // manage close animation
    closeModal: function(){

      this.show = false;
      setTimeout(function(vue){
        vue.$destroy();
      }, 200, this);

    },

    loadMedia: function(){

      var vue = this;
      vue.media_loading = true;

      axios({
        method: 'get',
        url: window.location.origin + '/data/media/get',
        params: {
          type: this.type
        }
      })
      .then(res => {
        if( res.data.media ) this.media = res.data.media;
      })  
      .catch(err => {
        vue.$store.commit('add_message', {
          type: 'error',
          message: err.response.message
        });
      })
      .then(() => {
        vue.media_loading = false;
      })

    },

    deleteMedia: function(){

      	

    },

    uploadMedia: function(){



    },

    selectMedia: function(){



    }

  },

  mounted: function(){

    // show component
    this.show = true;

  },

  // send modal destry to other components
  destroyed: function(){



  }

}
</script>

<style scoped>

</style>